import { paymentReminderCampaignRoutes } from "./payment-reminder-campaigns"

export * from "./payment-reminder-campaigns"



export const paymentsRoutes = paymentReminderCampaignRoutes